import { getCmsUrl } from "@/lib/app-config";

/** Deep link into Strapi Content Manager for a page document. */
export function buildStrapiPageEditUrl(
  id: string | number,
  locale?: string,
): string {
  // The CMS is served at the HOST ROOT — cms.<host>/content-manager/..., not /admin/... .
  // The old /admin URL still redirects, but a deep link should land in one hop.
  const base = `${getCmsUrl()}/content-manager/collection-types/api::page.page/${id}`;
  return locale ? `${base}?plugins[i18n][locale]=${locale}` : base;
}

/** CMS login handoff URL with redirect back to a content-manager deep link. */
export function buildCmsHandoffRedirectTarget(
  id: string | number,
  locale?: string,
): string {
  const path = buildStrapiPageEditUrl(id, locale).replace(getCmsUrl(), "");
  return path.startsWith("/") ? path : `/${path}`;
}
